<script>
    import { pubsConfig } from '../../store.js'

    export let pubsCategories

    function filterTerm (categoryName) {
        pubsConfig.update(config => {
            const newConfig = { ...config }
            if (newConfig.filterBy.includes(categoryName)) {
                newConfig.filterBy = []
            } else {
                newConfig.filterBy = [categoryName]
            }
            return newConfig
        })
    }

    function clearFilter () {
        pubsConfig.update(config => {
            const newConfig = { ...config }
            newConfig.filterBy = []
            return newConfig
        })
    }

</script>

<div class="filterBy">
    {#each pubsCategories.filter(category => category.priority == true) as category}
        <a
            class="categoryFilter priority"
            class:active={$pubsConfig.filterBy.includes(category.name)}
            href={'javascript:void(0)'}
            on:click={filterTerm(category.name)}
        >
            {category.name}
        </a>
    {/each}
    {#each pubsCategories.filter(category => category.priority == false) as category}
        <a
            class="categoryFilter"
            class:active={$pubsConfig.filterBy.includes(category.name)}
            href={'javascript:void(0)'}
            on:click={filterTerm(category.name)}
        >
            {category.name}
        </a>
    {/each}
    {#if $pubsConfig.filterBy.length != 0}
        <br />
        <br />
        <a
            class="clearFilter"
            href={'javascript:void(0)'}
            on:click={clearFilter}
        >
            Clear category filters
        </a>
    {/if}
</div>

<style lang="scss">
    @import "../../styles/vars";
    .clearFilter {
        border-bottom: 2px solid black !important;
    }
    @include respond-to(computer) {
        .filterBy {
            display: block;
        }
        .categoryFilter, .clearFilter {
            color: black;
            display:inline-block;
            font-family: 'Ysabeau';
            font-size: var(--filter-text-size);
            margin-right: 0.5rem;
            border-bottom: 2px solid transparent;
            &.priority {
                font-weight: bold;
            }
            &:hover {
                text-decoration: none;
            }
            &.active {
                border-bottom: 2px solid black;
            }
        }
    }
    @include respond-to(phone) {
        .clearFilter {
            margin-bottom: 0.5rem;
        }
        .filterBy {
            display: block;
        }
        .categoryFilter, .clearFilter {
            color: black;
            display:inline-block;
            font-family: 'Ysabeau';
            font-size: var(--filter-text-size-phone);
            line-height: 1.1rem;
            margin-right: 0.5rem;
            border-bottom: 2px solid transparent;
            &.priority {
                font-weight: bold;
            }
            &:hover {
                text-decoration: none;
            }
            &.active {
                border-bottom: 2px solid black;
            }
        }
    }
</style>
